import Alpine from 'alpinejs';
import './htmx';

window.Alpine = Alpine;
Alpine.start();
